module.exports = __webpack_public_path__ + "static/media/world-icon.2a0cfc82.svg";